/* ============================================================
   BARA NEW YORK — theme.js
   ============================================================ */

(function () {
  'use strict';

  // ── Hamburger / Mobile Menu ──────────────────────────────
  const ham = document.getElementById('hamburger');
  const mob = document.querySelector('.site-header__mobile-nav');

  if (ham && mob) {
    ham.addEventListener('click', () => {
      const isOpen = mob.classList.toggle('open');
      const spans = ham.querySelectorAll('span');
      if (isOpen) {
        spans[0].style.transform = 'rotate(45deg) translate(5px,5px)';
        spans[1].style.opacity = '0';
        spans[2].style.transform = 'rotate(-45deg) translate(5px,-5px)';
        document.body.style.overflow = 'hidden';
      } else {
        spans.forEach(s => { s.style.transform = ''; s.style.opacity = ''; });
        document.body.style.overflow = '';
      }
    });
  }

  window.closeMobile = function () {
    if (mob) mob.classList.remove('open');
    if (ham) ham.querySelectorAll('span').forEach(s => { s.style.transform = ''; s.style.opacity = ''; });
    document.body.style.overflow = '';
  };

  // Close mobile menu on escape key
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') window.closeMobile();
  });

  // ── Scroll Reveal ────────────────────────────────────────
  const revealObs = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('visible');
        revealObs.unobserve(e.target);
      }
    });
  }, { threshold: 0.08 });

  document.querySelectorAll('.reveal').forEach(el => revealObs.observe(el));

  // ── Newsletter Form ──────────────────────────────────────
  document.querySelectorAll('.newsletter-section__form').forEach(form => {
    form.addEventListener('submit', e => {
      e.preventDefault();
      form.innerHTML = '<p class="newsletter-section__success">🎉 Welcome to the family! Check your inbox for your 10% off code.</p>';
    });
  });

  // ── Collection page: Filter pills ───────────────────────
  const filterPills = document.querySelectorAll('.filter-pill');
  const productItems = document.querySelectorAll('[data-filter-cat]');
  const emptyState = document.getElementById('collectionEmpty');

  if (filterPills.length) {
    filterPills.forEach(pill => {
      pill.addEventListener('click', () => {
        filterPills.forEach(p => p.classList.remove('active'));
        pill.classList.add('active');
        const cat = pill.dataset.filter;
        let visible = 0;
        productItems.forEach(item => {
          const cats = item.dataset.filterCat || '';
          if (cat === 'all' || cats.includes(cat)) {
            item.style.display = '';
            visible++;
          } else {
            item.style.display = 'none';
          }
        });
        if (emptyState) emptyState.style.display = visible === 0 ? 'block' : 'none';
      });
    });
  }

  // ── Collection page: Sort ────────────────────────────────
  const sortSelect = document.getElementById('collectionSort');
  const productGrid = document.getElementById('collectionGrid');

  if (sortSelect && productGrid) {
    sortSelect.addEventListener('change', () => {
      const val = sortSelect.value;
      const items = [...productGrid.querySelectorAll('[data-price]')];
      items.sort((a, b) => {
        if (val === 'price-asc')  return +a.dataset.price - +b.dataset.price;
        if (val === 'price-desc') return +b.dataset.price - +a.dataset.price;
        if (val === 'name')       return a.dataset.name.localeCompare(b.dataset.name);
        return +a.dataset.order - +b.dataset.order; // featured
      });
      items.forEach(item => productGrid.appendChild(item));
    });
  }

  // ── Collection page: Grid / List view toggle ─────────────
  const gridBtn = document.getElementById('viewGrid');
  const listBtn = document.getElementById('viewList');

  if (gridBtn && listBtn && productGrid) {
    gridBtn.addEventListener('click', () => {
      productGrid.classList.remove('collection-grid--list');
      gridBtn.classList.add('active');
      listBtn.classList.remove('active');
    });
    listBtn.addEventListener('click', () => {
      productGrid.classList.add('collection-grid--list');
      listBtn.classList.add('active');
      gridBtn.classList.remove('active');
    });
  }

})();
